module.exports = __webpack_public_path__ + "static/img/h2.78e5fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h2.png
// module id = csBH
// module chunks = 1